import LeaveRequestDetailsPage from "../../../../components/company/performance/leave-request/LeaveRequestDetails";

export default LeaveRequestDetailsPage;